import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';

import {
  UniWorkflow,
  UniInput,
  UniToggle,
  UniLocalize,
  UniOverlapButton,
  UniOverlapGroup,
  Editable,
  IMultiInputUpdate,
  UniConditionalRender,
  minV10n,
  maxV10n
} from '@unikey/unikey-commons/release/comm';

import {
  toggleCreateOrgModal,
  attemptCreateNewOrg,
  handleCreateOrgChange,
  attemptRetrieveDealerDetails,
  attemptRetrieveOrganizations,
  PartnerCustomizations, IPartnerCustomizations
} from '../internal';

interface IProps extends WrappedComponentProps, IPartnerCustomizations {
  // history: any,
  newOrgName: Editable<string>,
  loading?: boolean,

  updateNewOrg(changes: IMultiInputUpdate): void
  toggleModal(): void,
  attemptCreateNewOrg(name: string): Promise<void>,
  getDealerAccountDetails(): Promise<void>,
  getOrgs(): Promise<void>,
}

class OrganizationCreateContainer extends Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  componentDidMount() {
    this.props.getDealerAccountDetails();
  }

  _saveOrgAndReloadList(preventSave: boolean) {
    if (!preventSave) {
      this.props.attemptCreateNewOrg(this.props.newOrgName.value).then(() => {
        this.props.getOrgs();
      })
    }
  }

  render() {
    if (this.props.render) {
      return this.props.render.apply(this);
    }
    return (
      <section className='orgCreate-container'>
        <UniWorkflow 
          titleKey="addNewOrganization"
          titleIcon="business"
          inModal
          handleClose={this.props.toggleModal}>

          <p><UniLocalize translate="_chooseOrganizationName" /></p>
          <UniInput
            editable={this.props.newOrgName}
            labelKey="organizationName"
            placeholderKey="organizationName"
            handleUpdate={(name: Editable<string>) => this.props.updateNewOrg({ name })}
            handleEnter={() => this._saveOrgAndReloadList(!this.props.newOrgName.value)}
            focusOnInitialRender={true} />


          {/* step actions */}
          <UniOverlapGroup>
            <UniOverlapButton
              handleClick={() => this._saveOrgAndReloadList(!this.props.newOrgName.value)}
              textKey="save"
              icon="save"
              disabled={!this.props.newOrgName.value}
              showLoader={!!this.props.loading} />
            <UniOverlapButton
              handleClick={this.props.toggleModal}
              textKey="cancel"
              icon="close"
              secondary={true} />
          </UniOverlapGroup>
        </UniWorkflow>
      </section>
    )
  }
}

function mapStateToProps(state: any) {
  return {
    newOrgName: state.createOrg.newOrg.name,
    loading: state.createOrg.loading,
  }
}

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  attemptCreateNewOrg,
  toggleModal: toggleCreateOrgModal,
  updateNewOrg: handleCreateOrgChange,
  getDealerAccountDetails: attemptRetrieveDealerDetails,
  getOrgs: attemptRetrieveOrganizations,
}, dispatch)

export default PartnerCustomizations(
  connect(mapStateToProps, mapDispatchToProps)(
    injectIntl(OrganizationCreateContainer)
  ), { componentName: 'OrganizationCreate' })
